import styled from 'styled-components';

import { primaryColor } from '~theme';

const Header = styled.h4`
  color: ${primaryColor};
  font-weight: 400;
  font-size: 32px;
  margin-bottom: 40px;
  padding-left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export default Header;
